export default[
    {
        path: '/vale/cadastro',
        name: 'cadastro dos vales', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/vale/lista',
        name: 'lista de vales', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/vale/editar/:id',
        name: 'editar vale', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]